export default "__VITE_ASSET__BmhhpScL__"